import React, { FC, useCallback } from 'react'
import styles from 'styles/components/template.module.scss'
import text from 'styles/utility/text.module.scss'
import { Spacer } from 'components/Utility'
import { FlexColumn } from 'components/Flex'
import { BlueButton, NavButton } from 'components/Button'
import { Description } from 'components/Typography'
import { dateToString } from 'lib/helper'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import { StockUnionType } from 'types/stock'

const ScheduleCollectiveEditCompleteTemplate: FC = () => {
  const dispatch = useDispatch()
  const confirmProduct = useCallback(() => dispatch(push(`/scheduled_item/${dateToString(new Date())}`)), [])
  return (
    <div className={styles.standard}>
      <Spacer size={48} />
      <FlexColumn alignItems={'center'}>
        <img src={'/icon/done/clock.svg'} alt={'商品の受渡可能日の設定が完了しました'} />
        <Spacer size={16} />
        <h2 className={`${text.font_xxxlarge} ${text.align_center}`}>
          商品の受渡可能日の設定が
          <br />
          完了しました
        </h2>
        <Spacer size={16} />
        <Description
          align={'center'}
          description={'販売予定の商品を確認するページから、\n正しく設定されているか確認してください'}
        />
      </FlexColumn>
      <Spacer size={48} />
      <BlueButton
        endIconPath={'/icon/white/arrow_next_small.svg'}
        label={'販売予定の商品を確認する'}
        onClick={confirmProduct}
        size={'medium'}
        type={'main'}
      />
      <Spacer size={12} />
      <NavButton label={'トップページに戻る'} iconPath={'/icon/grey/home.svg'} url={'/'} />
      <Spacer size={72} />
    </div>
  )
}

export default ScheduleCollectiveEditCompleteTemplate
